import { Injectable } from '@angular/core';

import { Fixture } from '@cds/betting-offer';
import { ShowcaseFixtureData } from '@cds/betting-offer/domain-specific/showcase';
import { FixtureFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';

import { ShowcaseEventModel, ShowcaseFixtureGroup, ShowcaseModuleData, ShowcaseModuleSitecoreItem } from './showcase.model';

@Injectable({ providedIn: 'root' })
export class ShowcaseFixtureMapperService {
    constructor(private fixtureFactory: FixtureFactory) {}

    mapShowcaseFixtures(fixtures: ShowcaseFixtureData[], showcaseModuleItem: ShowcaseModuleSitecoreItem[]): ShowcaseModuleData {
        if (!(fixtures && fixtures.length)) {
            return <ShowcaseModuleData>{};
        }

        const key = fixtures.map((f) => f.requestId)[0];
        const fixtureGroup = fixtures.filter((f) => f.requestId === key);

        const sitecoreShowcaseModuleItem = showcaseModuleItem.find((v) => v.contentSourceId === +key);

        let showcaseModuleTabEvents = fixtureGroup.map((fg) => this.eventModelWithOptionGroup(fg.fixture, sitecoreShowcaseModuleItem!));
        showcaseModuleTabEvents = showcaseModuleTabEvents.filter((item) => item.event.participants.length === 2);

        if (showcaseModuleTabEvents?.length) {
            showcaseModuleTabEvents[0].active = true;
        }

        return {
            title: sitecoreShowcaseModuleItem!.title,
            events: showcaseModuleTabEvents,
            showSpecialContents: sitecoreShowcaseModuleItem!.showSpecialContents,
        };
    }

    private eventModelWithOptionGroup(fixture: Fixture, sitecoreShowcaseModuleItem: ShowcaseModuleSitecoreItem): ShowcaseEventModel {
        const eventModel = this.fixtureFactory.create(fixture);

        return {
            gridGroup: this.getGridGroupId(sitecoreShowcaseModuleItem.fixtureGroup, fixture.sport.id),
            event: eventModel,
        };
    }

    private getGridGroupId(fixtureGroups: ShowcaseFixtureGroup[], sportId: number): { [key: string]: string } | undefined {
        const fixtureGroup = fixtureGroups.find((g) => g.sportId === sportId);

        return fixtureGroup?.gridGroup;
    }
}
